// The client side of GET /api/snapshots/:id — read-only, used to turn a bare `evidence_ref`
// (a snapshot id) into the URL and fetch date the DossierZone idiom shows beside a quote.
import { request } from './client.js';
import type { Snapshot } from '../../shared/types.js';

export function getSnapshot(id: number): Promise<Snapshot> {
  return request(`/snapshots/${id}`);
}
